<template>
  <section>
    <div class="modal-body">
      <form action="" class="m-form m-form--state">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row" :class="{'has-danger': errors.has('name')}">
            <div :class="validPermission('change','section') ? 'col-lg-11' : 'col-lg-12'">
              <label>{{'name' | translate | capitalize}}</label>
              <select v-model="section.name" id="name" name="name" class="form-control m-bootstrap-select m_selectpicker" data-live-search="true" :title="'select_an_option' | translate | capitalize" v-validate="'required'">
                <option v-for="phrase in names" :key="phrase.key" :value="phrase.key">{{ phrase.value | translate | capitalize }}</option>
              </select>
            </div>
            <div v-if="validPermission('create','phrase')" class="col-lg-1">
            <label>&nbsp;</label>
              <a class="btn btn-outline-success m-btn m-btn--icon m-btn--icon-only m-btn--outline-2x" data-toggle="modal" data-backdrop="static" data-keyboard="false" @click="changeModalPhraseStatus(true)" href="">
                <i class="flaticon-add"></i>
              </a>
            </div>
            <label v-show="errors.has('name')" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
            <span v-show="errors.has('name')" class="m-form__help m--font-danger">{{ errors.first('name') }}</span>
          </div>
          <div class="form-group m-form__group row" :class="{'has-danger':errors.has('permission')}">
            <div :class="validPermission('change','section') ? 'col-lg-11' : 'col-lg-12'">
              <label>{{'permission' | translate | capitalize}}</label>
              <select v-model="section.permission_id" id="permission" name="permission" class="form-control m-bootstrap-select m_selectpicker" data-live-search="true" :title="'select_an_option' | translate | capitalize" v-validate="'required'">
                <option v-for="permission in all_permissions" :key="permission.id" :value="permission.id">{{ permission.name | translate | capitalize }}</option>
              </select>
            </div>
            <div v-if="validPermission('create','permission')" class="col-lg-1">
              <label>&nbsp;</label>
              <a class="btn btn-outline-success m-btn m-btn--icon m-btn--icon-only m-btn--outline-2x" data-toggle="modal" title="add permission" data-backdrop="static" data-keyboard="false" href="" @click="updateModalStatus(true)">
                <i class="flaticon-add"></i>
              </a>
            </div>
            <label v-show="errors.has('permission')" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
            <span v-show="errors.has('permission')" class="m-form__help m--font-danger">{{ errors.first('permission') }}</span>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{'parent' | translate | capitalize}}</label>
              <select v-model="section.section_id" id="section" name="section" class="form-control m-bootstrap-select m_selectpicker" :title="'select_an_option' | translate | capitalize">
                <option v-for="section in all_sections.sections" :key="section.id" :value="section.id">{{ section.name | translate | capitalize }}</option>
              </select>
            </div>
            <div class="col-lg-6">
              <label>{{'visibility' | translate | capitalize}}</label>
              <select v-model="section.visibility" id="visibility" name="visibility" class="form-control m-bootstrap-select m_selectpicker" :title="'select_an_option' | translate | capitalize">
                <option value="0">{{ 'shared' | translate | capitalize }}</option>
                <option value="1">{{ 'cloud' | translate | capitalize }}</option>
                <option value="2">{{ 'ground' | translate | capitalize }}</option>
              </select>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-6" v-if="section.section_id == ''" :class="{'has-danger':errors.has('icon')}">
              <label>{{'icon' | translate | capitalize}}</label>
              <input type="text" name="icon" v-model="section.icon" class="form-control form-control-danger m-input" v-validate="{regex:/^[a-zA-Z0-9\- \s]*$/}">
              <span v-show="errors.has('icon')" class="m-form__help m--font-danger">{{ errors.first('icon') }}</span>
            </div>
            <div :class="[{'has-danger': errors.has('route')}, section.section_id == '' ? 'col-lg-6' : 'col-lg-6' ]">
              <label>{{'route' | translate | capitalize}}</label>
              <input type="text" name="route" v-model="section.route" class="form-control form-control-danger m-input" v-validate="{regex:/^[a-z\/\_\-\#]*$/}">
              <span v-show="errors.has('route')" class="m-form__help m--font-danger">{{ errors.first('route') }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" id="btn-cloModalSection" class="btn btn-secondary" data-dismiss="modal" @click="resetForm">
        {{ 'cancel' | translate | capitalize}}
      </button>
      <button type="button" class="btn btn-primary" @click="validateForm">
        {{ 'submit' | translate | capitalize}}
      </button>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    props: ['data'],
    data () {
      return {
        section: {
          name: '',
          permission_id: '',
          section_id: '',
          visibility: '',
          icon: '',
          route: ''
        },
        names: [],
        edit: false
      }
    },
    created () {
      this.getOptions()
    },
    computed: {
      ...mapGetters({all_permissions: 'activatePermissions',
        all_sections: 'allSections',
        edit_status: 'getEditStatus',
        section_modal: 'getStatusSectionModal',
        modal_phrases: 'getModalPhraseStatus',
        user_permissions: 'getUserPermissions'})
    },
    methods: {
      ...mapActions(['saveSection', 'modifySection', 'updateStateSectionModal',
        'updateEditStatus', 'phrasesLanguage', 'changeModalPhraseStatus', 'updateModalStatus']),
      validateForm () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$spinner.show()
            if (this.edit) {
              this.modifySection(this.section)
                .then((res) => {
                  this.$spinner.remove()
                  document.getElementById('btn-cloModalSection').click()
                  this.$toast('modify_section_message')
                })
                .catch((err) => {
                  this.$spinner.remove()
                  // this.section.name = this.names.find(p => p.value === this.section.name)
                  // this.section.permission_id = this.permission_options.find(p => p.value === this.section.permission_id)
                  this.$toast('modify_section_error', 4)
                  console.log(err)
                })
            } else {
              this.saveSection(this.section).then((res) => {
                this.$spinner.remove()
                document.getElementById('btn-cloModalSection').click()
                this.$toast('new_section_message')
                Object.keys(this.section).forEach((key, index) => { this.section[key] = '' })
              }).catch((error) => {
                this.$spinner.remove()
                // this.section.name = this.names.find(p => p.value === this.section.name)
                // this.section.permission_id = this.permission_options.find(p => p.value === this.section.permission_id)
                this.$toast('new_section_error', 4)
                console.log(error)
              })
            }
          }
        })
      },
      resetForm () {
        this.updateModalStatus(false)
        this.updateStateSectionModal(false)
        this.updateEditStatus(false)
        this.section = {
          name: '',
          permission_id: '',
          section_id: '',
          icon: '',
          route: ''
        }
        this.edit = false
      },
      getOptions () {
        this.phrasesLanguage(this.$i18n.locale)
          .then((result) => {
            this.names = result.data[0].phrases
          })
          .catch((result) => {
            console.log(result)
          })
      },
      validPermission (action, entity) {
        if (this.user_permissions.find(p => { return (p.action === action && p.entity === entity) })) {
          return true
        } else {
          return false
        }
      }
    },
    watch: {
      section_modal (newVal, oldVal) {
        const $ = window.$
        $('.m_selectpicker').selectpicker('refresh')
        if (oldVal === false && newVal === true) {
          this.errors.clear()
        }
        this.errors.clear()
      },
      edit_status (newVal, oldVal) {
        const $ = window.$
        if (oldVal === false && newVal === true) {
          this.$nextTick(() => {
            this.edit = true
            this.data.section_id = this.data.section_id ? this.data.section_id : ''
            $('.m_selectpicker').selectpicker('refresh')
            $('#name').selectpicker('val', this.data.name)
            $('#permission').selectpicker('val', this.data.permission_id)
            $('#section').selectpicker('val', this.data.section_id)
            $('#visibility').selectpicker('val', this.data.visibility)
            this.section = JSON.parse(JSON.stringify(this.data))
          })
        }
      },
      modal_phrases (newVal, oldVal) {
        if (oldVal === true && newVal === false) {
          this.names = []
          this.getOptions()
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SectionForm.vue